import { useQuery } from "react-query";
import {
	fetchAnnouncements,
	fetchAnnouncement,
} from "../queries/announcements.queries";
import type { PaginatedFilter } from "../types/axios.types";
import type { AnnouncementType } from "../types/announcement.types";

export const useAnnouncement = (type: AnnouncementType) => {
	return useQuery({
		queryKey: ["announcement", type],
		queryFn: () => fetchAnnouncement(type),
	});
};

export const useAnnouncements = (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const query = useQuery(
		["announcements", page, size, search, filters, sortBy],
		() => {
			try {
				return fetchAnnouncements(page, size, search, filters, sortBy);
			} catch (err) {
				return null;
			}
		},
		{ keepPreviousData: true },
	);
	return query?.data;
};
